<template>
  <div class="thredd-login-logo">
    <img src="@/assets/img/jackhenry-logo.png" />
  </div>
</template>

<script setup lang="ts"></script>

<style></style>
